module.exports = __webpack_public_path__ + "static/media/map-osm.b91b2524.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/map-osm.png
// module id = 409
// module chunks = 0